// extracted by mini-css-extract-plugin
export default {"scrolling-container":"main-layout_scrolling-container__s+AFU"};